(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flow-finder"] && !Shopify.designMode) return;
  try {
    
function setupFlowFinder(){document.querySelectorAll('[data-flow-finder]').forEach(form=>{if(form.dataset.ready)return;form.dataset.ready='true';form.addEventListener('submit',event=>{event.preventDefault();const phase=new FormData(form).get('phase');const target={before:'/collections/before-activity',during:'/collections/during-activity',after:'/collections/after-activity'}[phase];const duration=form.querySelector('#duration').value;const result=form.querySelector('[data-flow-result]');const templates=form.closest('.flow-homepage').querySelectorAll('template[data-phase]');const template=[...templates].find(t=>t.dataset.phase===phase);result.replaceChildren(template.content.cloneNode(true));result.querySelector('a').href=target;const longNote=result.querySelector('[data-long-note]');if(longNote)longNote.hidden=duration!=='long';});});}document.addEventListener('DOMContentLoaded',setupFlowFinder);document.addEventListener('shopify:section:load',setupFlowFinder);setupFlowFinder();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class LoadMedia extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const deferredMediaBtn = this.closest('.video-section').querySelector('.js-load-media');
      button.addEventListener('click', () => deferredMediaBtn.click());
    }
  }
  customElements.define('load-media', LoadMedia);

  } catch(e) { console.error(e); }
})();
})();
